import { onInit } from "../../../exports/tracking";
import { loggerScope } from "../parser/utils";
import type { DataTrRaw } from "../index.js";
import { getLockInitTokenFromElement, getTrackingAttributes } from "../parser/attributes";
import { lifecycleEvents } from "../event/event";
import type { registerTrackingHandler } from "./register";
import type { NexusHandler } from "../../nexus/function/function.types";

const log = loggerScope.scope("defer");

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export interface ReleaseLock extends Disposable {
  /**
 *
 */
  (): boolean;
}

/**
 *
 *
 *
 */
export const globalLocks = new Set<symbol | string | object>();

export const unlocked = Symbol("unlocked");

export const elementLocks = new Map<symbol | string | object, HTMLElement | typeof unlocked>();

/**
 *
 *
 *
 *
 */
export function triggerGlobalInitIfReleased(): boolean {
  if (globalLocks.size > 0) return false;
  log.info("All deferration locks released, triggering global init");
  onInit.dispatch({ retain: true });
  return true;
}

/**
 *
 *
 *
 *
 *
 *
 */
export function triggerElementInitIfReleased(
  lockToken: string | symbol | object,
  unlock: boolean,
): boolean {
  const lock = elementLocks.get(lockToken);

  /*                                                                          */
  if (unlock) {
    log.debug("Unlock", lockToken, "in advance");
    elementLocks.set(lockToken, unlocked);
  }

  /*                                                                   */
  if (!lock || lock === unlocked) return false;

  log.debug("Lock released for element", lockToken, "triggrer element init");
  lock.dispatchEvent(
    new CustomEvent(lifecycleEvents[2], { bubbles: false, detail: { lockToken } }),
  );

  return true;
}

export const unlockInit = function unlockInit(lockToken) {
  log.info("Release init lock by:", lockToken);

  globalLocks.delete(lockToken);
  const globalRes = triggerGlobalInitIfReleased();

  const elementRes = triggerElementInitIfReleased(lockToken, true);
  return globalRes || elementRes;
} satisfies NexusHandler<DataTrRaw["unlockInit"]>;

/**
 *
 */
export const lockInit = function lockInit(lockToken) {
  log.info("Lock init by", lockToken);
  globalLocks.add(lockToken);

  const unlock: ReleaseLock = () => unlockInit(lockToken) as never;
  unlock[Symbol.dispose] = unlock;
  return unlock;
} satisfies NexusHandler<DataTrRaw["lockInit"]>;

/**
 *
 *
 *
 *
 *
 */
export function withInitLock(
  elementToTrack: HTMLElement,
  initializer: typeof registerTrackingHandler,
): void {
  const attrs = getTrackingAttributes(elementToTrack);

  /*                                                          */
  const lockInitToken = getLockInitTokenFromElement(elementToTrack, attrs);
  if (!lockInitToken) return initializer(elementToTrack, attrs);

  /*                                                                       */
  if (elementLocks.get(lockInitToken) === unlocked) return initializer(elementToTrack, attrs);

  log.debug("Lock init for", elementToTrack, lockInitToken);
  elementLocks.set(lockInitToken, elementToTrack);

  elementToTrack.addEventListener(
    lifecycleEvents[2],
    (ev) => {
      if (ev.detail.lockToken !== lockInitToken) return;
      initializer(elementToTrack, attrs);
    },
    { once: true },
  );
}
